import { useState } from "react";
import { Share2, Link2, Check } from "lucide-react";

export const ShareRow = ({ title, testId = "share" }) => {
  const [copied, setCopied] = useState(false);
  const url = typeof window !== "undefined" ? window.location.href : "";
  const text = `${title} — iINSPIRE`;
  const links = [
    { id: "whatsapp", label: "WhatsApp", href: `https://wa.me/?text=${encodeURIComponent(`${text}\n${url}`)}` },
    { id: "facebook", label: "Facebook", href: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}` },
    { id: "x", label: "X", href: `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}` },
    { id: "linkedin", label: "LinkedIn", href: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}` },
  ];
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = url;
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand("copy");
      } catch {}
      ta.remove();
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  const pill =
    "inline-flex items-center gap-1.5 border border-ink/15 px-3 py-1.5 text-[10px] font-semibold uppercase tracking-[0.12em] text-ink/70 transition-colors duration-200 hover:border-amber hover:text-ink";
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={`${testId}-row`}>
      <span className="mr-1 inline-flex items-center gap-2 text-[10px] font-semibold uppercase tracking-[0.25em] text-ink/45">
        <Share2 className="h-3.5 w-3.5" strokeWidth={1.5} /> Share this
      </span>
      {links.map((l) => (
        <a key={l.id} href={l.href} target="_blank" rel="noopener noreferrer" className={pill} data-testid={`${testId}-${l.id}`}>
          {l.label}
        </a>
      ))}
      <button type="button" onClick={copy} className={pill} data-testid={`${testId}-copy`}>
        {copied ? <Check className="h-3.5 w-3.5" strokeWidth={1.5} /> : <Link2 className="h-3.5 w-3.5" strokeWidth={1.5} />}
        {copied ? "Copied" : "Copy Link"}
      </button>
    </div>
  );
};
